var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 448 448",
    style: {
      enableBackground: "new 0 0 448 448"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M189.2,141.9h-69.4c-35-9.6-114.2-7.1-114.2,68.2c0,27.4,13.1,46.6,30.6,55.6c-22,21-32.4,30.9-32.4,44.8 c0,10,3.9,19.2,15.7,24.4C7.1,347.1,0,356,0,372.7C0,402,24.6,419,88.9,419c61.9,0,97.8-24.1,97.8-66.7c0-53.5-39.5-51.5-132.6-57.4 l11.7-19.7c23.9,6.9,103.8,9.1,103.8-61.9c0-17-6.7-28.9-13.1-37.4l32.7-2.6L189.2,141.9z M133.8,362.3c0,29.2-91.8,29.2-91.8,2.2 c0-7.4,4.6-13.7,9.3-19.6C119.2,349.8,133.8,348,133.8,362.3z M89.3,239.7c-46.2,0-44.2-64.9,1-64.9 C133.7,174.8,134.8,239.7,89.3,239.7z M205.9,331.3V302c23.4-3.4,23.8-1.8,23.8-10V183.1c0-7.7-1.8-6.7-23.8-14.9l3.9-30h73.6V292 c0,5.9,0.3,6.7,5.7,7.4l18.1,2.6v29.2L205.9,331.3z M251.9,108.7c-20.3,0-32-12.2-32-33.3s11.7-32.6,32-32.6 c20.6,0,32.4,11.5,32.4,32.6S272.5,108.7,251.9,108.7z M447.9,317c-15.3,7.7-37.7,14.9-58,14.9c-42.3,0-58.3-17.8-58.3-59.7v-97 c0-4.9,1-3.7-27.7-3.7v-33c31.3-3.7,43.7-20,47.7-60.4h33.8c0,60-1.1,56.3,2.9,56.3h50.1v37.1h-53v88.6c0,6.3-4.3,46.8,53,24.4 L447.9,317z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGit);
export default __webpack_public_path__ + "static/media/git.ecb03f110c8499bb45df0dcb49cdf489.svg";
export { ForwardRef as ReactComponent };